import { useSelector } from "react-redux";
import { RootState } from "store";

const TIMEFRAME_TO_MS: Record<string, number> = {
  "5S": 5_000,
  "10S": 10_000,
  "15S": 15_000,
  "30S": 30_000,
  "45S": 45_000,
  "1M": 60_000,
  "3M": 180_000,
  "5M": 300_000,
  "15M": 900_000,
  "30M": 1_800_000,
  "1H": 3_600_000,
  "4H": 14_400_000,
  "1D": 86_400_000,
};

export const useTimeframe = () => {
  const selectedTimeframe = useSelector(
    (state: RootState) => state.trading.selectedTimeframe,
  );

  const getTimeframeMs = (timeframe?: string | null): number => {
    if (!timeframe) return 60000;
    const normalized = timeframe.toUpperCase();
    return TIMEFRAME_TO_MS[normalized] ?? 60000;
  };

  const timeframeMs = getTimeframeMs(selectedTimeframe);

  return {
    selectedTimeframe,
    timeframeMs,
    getTimeframeMs,
  };
};
